"use client"

import { InscalarSDK } from '@ilg-core/inscalar-web'
import type { AnalyticsProvider } from '../types'
import datadog from '@ilg-core/analytics/datadog'

export const inscalarProvider: AnalyticsProvider = {
  name: 'inscalar',

  logEvent(
    eventName: string,
    eventParameters?: Record<string, string | number>,
    eventVersion: string = '1.0'
  ) {
    InscalarSDK.track(eventName, eventVersion, {}, { ...eventParameters, platform: 'web' })
  },

  logError(eventName, params) {
    // Inscalar does not have a dedicated error logging method
    datadog.log.error('[Inscalar]' + eventName, {
      ...params,
      statusMessage: eventName,
    })
  },
}